const STYLES = {
  "Your shop data": "bg-[#5EE6D0]/10 text-[#8FF0E0] border-[#5EE6D0]/30",
  "Etsy market count": "bg-[#8B7CFF]/12 text-[#C2BAFF] border-[#8B7CFF]/35",
  Estimate: "bg-white/[0.05] text-[#C9C8DC] border-white/15",
  "Demo data": "bg-[#E9C98B]/15 text-[#F3DDAE] border-[#E9C98B]/45",
};

export const SourceChip = ({ label, testid }) => (
  <span
    data-testid={testid || "source-chip"}
    data-source={label}
    className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${STYLES[label] || STYLES.Estimate}`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-current opacity-60" />
    {label}
  </span>
);

export const band = (s) => (s >= 75 ? "green" : s >= 50 ? "yellow" : "red");

const BAND = {
  green: "bg-emerald-400/10 text-emerald-200 border-emerald-300/30",
  yellow: "bg-amber-300/10 text-amber-100 border-amber-200/30",
  red: "bg-rose-400/10 text-rose-200 border-rose-300/30",
};
const DOT = { green: "bg-emerald-300 shadow-[0_0_8px_#6ee7b7]", yellow: "bg-amber-200 shadow-[0_0_8px_#fde68a]", red: "bg-rose-300 shadow-[0_0_8px_#fda4af]" };
const RING = { green: "#6EE7B7", yellow: "#F5D88A", red: "#FB9AAE" };

export const ScoreRing = ({ score, size = 88, stroke = 6, testid, label }) => {
  const b = band(score);
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return (
    <span data-testid={testid} data-band={b} className="relative inline-grid place-items-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.08)" strokeWidth={stroke} fill="none" />
        <circle cx={size / 2} cy={size / 2} r={r} stroke={RING[b]} strokeWidth={stroke} fill="none" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c * (1 - score / 100)} style={{ filter: `drop-shadow(0 0 6px ${RING[b]}88)`, transition: "stroke-dashoffset 1.2s ease" }} />
      </svg>
      <span className="absolute inset-0 grid place-items-center">
        <span className="text-center leading-none">
          <span className="font-display block" style={{ fontSize: size * 0.36 }}>{score}</span>
          {label && <span className="mt-0.5 block text-[9px] uppercase tracking-[0.18em] text-muted-foreground">{label}</span>}
        </span>
      </span>
    </span>
  );
};

export const ScoreBadge = ({ score, size = "sm", testid }) => {
  const b = band(score);
  if (size === "lg") return <ScoreRing score={score} testid={testid || "health-score-badge"} label="health" />;
  return (
    <span
      data-testid={testid || "health-score-badge"}
      data-band={b}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 font-mono text-xs font-medium ${BAND[b]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${DOT[b]}`} />
      {score}
    </span>
  );
};

export const Stat = ({ label, value, source, testid, hint }) => (
  <div data-testid={testid} className="glass hairline-gold lift min-w-0 rounded-2xl border p-5 sm:p-6">
    <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-muted-foreground">{label}</p>
    <p className="mt-3 font-display text-4xl sm:text-5xl leading-none break-words">{value}</p>
    {hint && <p className="mt-2 text-xs text-muted-foreground">{hint}</p>}
    <div className="mt-4"><SourceChip label={source} testid={`${testid}-source`} /></div>
  </div>
);
